import './index.less';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import * as actions from 'modules/actions/menuCount';
import { Menu, Badge } from '@beehive/components';
import { NavLink } from 'react-router-dom';
import { MenuType } from 'modules/types/account';
import { MenuCountState } from 'modules/types/menuCount';
import Setting from './Setting';
import * as H from 'history';
import _ from 'lodash';
import PropTypes from 'prop-types';
import messages from 'messages';
import { localPx2rem } from '@mpc/common/src/';

export interface HeaderProps extends Partial<MenuCountState> {
  selectedMenu: string;
  menus: MenuType[];
  leftSideWidth: number;
  secondaryMenus: MenuType[];
  secondayDefaultMenu: string;
  selectedPrimaryMenu: string;
  getMenuCount?: any;
  permissions: string[];
  history: H.History;
  location: H.Location;
}

export const getSecondaryMenus = (menus: MenuType[], selectedPrimaryMenu: string) => {
  const selectIndex = menus.findIndex((menu: MenuType) => menu.key === selectedPrimaryMenu);
  return !!~selectIndex ? menus[selectIndex].children || [] : [];
};

class Header extends React.Component<HeaderProps, any> {
  private headerPrimayRef: React.RefObject<HTMLDivElement>;
  public static contextTypes = {
    intl: PropTypes.object,
  };
  constructor(props: HeaderProps) {
    super(props);
    this.headerPrimayRef = React.createRef();
  }

  public componentDidMount() {
    this.getMenuCount();
    this.handleWindowResize();
  }

  componentDidUpdate(prevProps: HeaderProps) {
    const { selectedMenu: prevSelectedMenu } = prevProps;
    const { selectedMenu } = this.props;
    const prevGroupKey = prevSelectedMenu.split('/')[0];
    const groupKey = selectedMenu.split('/')[0];

    if (prevGroupKey && groupKey && prevGroupKey !== groupKey) {
      this.getMenuCount();
    }

    this.handleWindowResize();
  }

  getMenuCount = () => {
    const { selectedMenu, getMenuCount } = this.props;
    const groupKey = selectedMenu.split('/')[0];
    getMenuCount(actions.GROUP_MODULE_MAP[groupKey || '']);
  }

  public handleSelectMenu = () => {
    this.getMenuCount();
  }

  public handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, key: string) => {
    if (key === 'projectDetailSingle' || key === 'help') {
      e.preventDefault();
    }
  }

  public handleSelectSecondaryMenu = () => {
    this.getMenuCount();
  }

  public handleWindowResize = () => {
    if (this.headerPrimayRef && this.headerPrimayRef.current) {
      const headerPrimaryDom = this.headerPrimayRef.current;
      const settingDom = headerPrimaryDom.querySelector('.header-setting');
      if (settingDom) {
        headerPrimaryDom.style.paddingRight = settingDom.getBoundingClientRect().width + 'px';
      }
    }
  }

  public render() {
    const { intl } = this.context;
    const {
      menus,
      selectedMenu,
      leftSideWidth,
      secondaryMenus,
      secondayDefaultMenu,
      selectedPrimaryMenu,
      menuCount = [],
      permissions = [],
    } = this.props;
    const selectedMenuKey = selectedMenu.split('/')[0];
    // 减去1是防止有分割线
    const style = {
      paddingLeft: localPx2rem(leftSideWidth - 1),
    };
    return (
      <div className="mpc-header" style={style}>
        <div className="mpc-header-primary" style={{ paddingLeft: 64, paddingRight: 250}} ref={this.headerPrimayRef}>
          <Menu
            mode="horizontal"
            selectedKeys={[selectedPrimaryMenu]}
            level={1}
            onSelect={this.handleSelectMenu}
            overflowedIndicator={intl.formatMessage(messages.menuOverflowedIndicator)}
          >
            {
              menus.map((menu: MenuType) => {
                const itemCount = (menuCount.find((i: any) => i.key === menu.key) || {})['count'];
                return (
                  <Menu.Item key={menu.key}>
                    <NavLink
                      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => this.handleNavClick(e, menu.key)}
                      to={`/${selectedMenuKey}/${menu.key}`}
                      activeClassName="header-nav-selected"
                    >
                      {
                        itemCount ? (
                          <Badge count={itemCount}>{menu.name}</Badge>
                        ) : <span>{menu.name}</span>
                      }
                    </NavLink>
                  </Menu.Item>
                );
              })
            }
          </Menu>
          <Setting permissions={permissions}/>
        </div>
        {
          !!secondaryMenus.length && (
            <Menu
              mode="horizontal"
              defaultSelectedKeys={[_.camelCase(secondayDefaultMenu)]}
              levelStyle="secondary"
              onSelect={this.handleSelectSecondaryMenu}
            >
              {
                secondaryMenus.map((menu: MenuType) => {
                  const itemCount = (menuCount.find((i: any) => i.key === menu.key) || {})['count'];
                  return (
                    <Menu.Item key={_.camelCase(menu.key)}>
                      <NavLink
                        to={`/${selectedMenuKey}/${selectedPrimaryMenu}/${_.camelCase(menu.key)}`}
                        activeClassName="header-nav-selected"
                      >
                        {
                          itemCount ? (
                            <Badge count={itemCount}>{menu.name}</Badge>
                          ) : <span>{menu.name}</span>
                        }
                      </NavLink>
                    </Menu.Item>
                  );
                })
              }
            </Menu>
          )
        }
      </div>
    );
  }
}

const mapState2Props = (state: any) => {
  const { menuCount } = state;
  return {
    ...menuCount,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<actions.GetMenuCountSuccess>) => {
  return bindActionCreators({
    getMenuCount: actions.getMenuCount,
  }, dispatch);
};

export default connect(mapState2Props, mapDispatchToProps, undefined, { forwardRef: true })(Header);
